/**
 * @generated SignedSource<<28152e0fd82463bb04d925e467b2c53c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppTab_tab$data = {
  readonly appId: string | null | undefined;
  readonly envLabel: string | null | undefined;
  readonly iconUrl: string | null | undefined;
  readonly label: string;
  readonly sections: ReadonlyArray<{
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly styleClass: string | null | undefined;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"AppTabMenu_tab" | "TabWithMenu_tab">;
  readonly " $fragmentType": "AppTab_tab";
};
export type AppTab_tab$key = {
  readonly " $data"?: AppTab_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppTab_tab">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "label"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AppTab_tab",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_tab"
    },
    {
      "kind": "FragmentSpread",
      "name": "AppTabMenu_tab"
    },
    {
      "kind": "RequiredField",
      "field": (v0/*: any*/),
      "action": "THROW",
      "path": "label"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "url"
      },
      "action": "THROW",
      "path": "url"
    },
    {
      "kind": "ScalarField",
      "name": "appId"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    },
    {
      "kind": "ScalarField",
      "name": "styleClass"
    },
    {
      "kind": "ScalarField",
      "name": "envLabel"
    },
    {
      "concreteType": "JiraAppSection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ],
  "type": "JiraAppNavigationItem"
};
})();

(node as any).hash = "93b2820577820b8e46d082f49f2dc9ff";

export default node;
